module.exports = __webpack_public_path__ + "img/xcx_qrcode.3225667d.jpg";